export default [
  {
    text: 'table.table.number',
    value: 'number',
    sortable: true,
  },
  {
    text: 'table.table.description',
    value: 'description',
  },
  {
    text: 'table.table.active',
    value: 'active',
    type: 'slot',
    sortable: true,
  },
  {
    text: 'table.table.tags',
    value: 'tags',
    type: 'slot',
  },
  {
    text: 'table.table.qr',
    value: 'qrCode',
    type: 'qr',
  },
];
